/* 🤖 this file was generated by svg-to-ts */
export var spxIconSearch = {
    name: 'search',
    data: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\"><path d=\"M13.125 13.125L16.5 16.5\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M15 8.25C15 4.52208 11.9779 1.5 8.25 1.5C4.52208 1.5 1.5 4.52208 1.5 8.25C1.5 11.9779 4.52208 15 8.25 15C11.9779 15 15 11.9779 15 8.25Z\" stroke-width=\"1.5\" stroke-linejoin=\"round\"/></svg>"
};
